import React, { useEffect, useState } from 'react'
import { useStateContext } from '../../../context/ContextProvider'
import axiosClient from '../../../axios-client'
import { Bar, Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';

import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Avatar, Badge, Box, Button, Card, CardBody, CardHeader, CloseButton, Collapse, Divider, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex, Grid, Icon, IconButton, Image, Input, Progress, Select, SimpleGrid, Stack, Stat, StatLabel, StatNumber, Text, useColorModeValue, useDisclosure, useToast, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody, InputGroup, InputRightElement } from '@chakra-ui/react';
import { MdAddShoppingCart, MdOutlineAddShoppingCart, MdOutlineBarChart, MdOutlineRemoveShoppingCart } from 'react-icons/md';
import { TbTruckDelivery, TbTruckReturn } from 'react-icons/tb';
import { LuPackageX } from 'react-icons/lu';
import IconBox from '../../../components/Icons/IconBox';
import { useTranslation } from 'react-i18next';
import LineChart from '../../../components/Charts/LineChart';
import Slider from 'react-slick';
import { IoIosArrowForward } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LiaShippingFastSolid } from 'react-icons/lia';
import { GrPowerReset } from 'react-icons/gr';
import { DateRange } from 'react-date-range';
import format from 'date-fns/format';
import fr from 'date-fns/locale/fr';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { AsyncPaginate } from 'react-select-async-paginate';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

const styles = `
    .slick-prev:before, .slick-next:before {
    color: purple;
    font-size: 25px;
    
}

.slider-container .slick-prev, .slider-container .slick-next {
    z-index: 1; 
}`
function StatsCard({ title, stat, icon }) {
    return (
        <Stat
            px={{ base: 2, md: 2 }}
            py={'3'}
            shadow={'lg'}
            border={'1px'}
            borderColor={useColorModeValue('gray.300', 'gray.500')}
            rounded={'lg'}
        >
            <Flex w={"100%"} justifyContent={'space-between'}>
                <Box w={"70%"} pl={{ base: 2, md: 3 }}>
                    <StatLabel fontSize={"md"} fontWeight={'medium'} >
                        {title}
                    </StatLabel>
                    <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
                        {stat}
                    </StatNumber>
                </Box>
                <Box
                    display={"flex"}
                    justifyContent={"center"}
                    w={"30%"}
                    my={'auto'}
                    color={useColorModeValue('gray.800', 'gray.200')}
                    alignContent={'center'}
                >
                    {icon}
                </Box>
            </Flex>
        </Stat>
    );
}
function UsersStatsCard({ title, stat, icon }) {
    return (
        <Stat
            px={{ base: 2, md: 2 }}
            py={'3'}
            shadow={'lg'}
            border={'1px'}
            borderColor={useColorModeValue('gray.300', 'gray.500')}
            rounded={'lg'}
        >
            <Flex w={"100%"} justifyContent={'space-between'}>
                <Box w={"100%"} pl={{ base: 2, md: 3 }}>
                    <StatLabel fontSize={"md"} fontWeight={'medium'} >
                        {title}
                    </StatLabel>
                    <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
                        {stat}
                    </StatNumber>
                </Box>

            </Flex>
        </Stat>
    );
}

function Statistics() {
    const { user, setUser, setToken, currentBusiness } = useStateContext()
    const { t } = useTranslation();
    const { isOpen, onToggle, onClose } = useDisclosure()
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isCollapseOpen, setIsCollapseOpen] = useState(false);
    const [isCollapseUsersOpen, setIsCollapseUsersOpen] = useState(false);
    const firstField = React.useRef()
    const [resetting, setResetting] = useState(false);
    const [SelectedSuiviUser, setSelectedSuiviUser] = useState("");
    const navigate = useNavigate()

    const onOpenDrawer = () => {
        setIsDrawerOpen(true);
    };
    const onCloseDrawer = () => {
        setIsDrawerOpen(false);
    };
    const onOpenCollapse = () => {
        setIsCollapseOpen(true);
    };
    const onCloseCollapse = () => {
        setIsCollapseOpen(false);
    };
    const onOpenUsersCollapse = () => {
        setIsCollapseUsersOpen(true);
    };
    const onCloseUsersCollapse = () => {
        setIsCollapseUsersOpen(false);
    };

    const [countNew, setCountNew] = useState()
    const [countConfirmed, setCountConfirmed] = useState()
    const [countPending, setCountPending] = useState()
    const [countAnnule, setCountAnnule] = useState()
    const [countLivre, setCountLivre] = useState()
    const [countRetour, setCountRetour] = useState()

    const [dateStart, setDateStart] = useState('')
    const [dateEnd, setDateEnd] = useState('')

    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    const handleSelect = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        setSelectionRange(ranges.selection);
        setDateStart(format(startDate, 'yyyy-MM-dd'));
        setDateEnd(format(endDate, 'yyyy-MM-dd'));
    };

    const [lineChartData, setLineChartData] = useState(null);
    const [slider, setSlider] = useState(null)
    const [imagesProduct, setImagesProduct] = useState([])
    const [products, setProducts] = useState([])
    const [users, setUsers] = useState([])

    const [chiffreAffaire, setChiffreAffaire] = useState()
    const [chiffreAffaireConverted, setChiffreAffaireConverted] = useState(null);
    const [exchangeRate, setExchangeRate] = useState(null);
    const [chargesStats, setChargesStats] = useState()

    const [chargesData, setChargesData] = useState();
    const [costsData, setCostsData] = useState();
    const [tauxData, setTauxData] = useState();

    const [selectedProduct, setSelectedProduct] = useState('')
    const [selectedProductObj, setSelectedProductObj] = useState(null);
    const [productId, setProductId] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);

    const [productStats, setProductStats] = useState();
    const [usersStatsSuivi, setUsersStatsSuivi] = useState();
    const [usersStatsStock, setUsersStatsStock] = useState();
    const currentYear = new Date().getFullYear();
    const [year, setYear] = useState(currentYear);

    const toast = useToast();


    const generateYearOptions = () => {
        const yearOptions = [];
        for (let year = 2024; year <= currentYear; year++) {
            yearOptions.push(
                <option key={year} value={year}>
                    {year}
                </option>
            );
        }
        return yearOptions;
    };


    const handleYearChange = (event) => {
        setYear(event.target.value);
        if (event.target.value === "0") {
            setYear(currentYear)
        }
    };

    const fetchBarData = (userId, userRole) => {
        axiosClient.get(`/commandes/getCommandesCount/?client=${userId}&product=${selectedProduct}&dateStart=${dateStart}&dateEnd=${dateEnd}&userRole=${userRole}&business=${currentBusiness?.id}`)
            .then((res) => {
                setCountNew(res.data.count_new);
                setCountPending(res.data.count_pending);
                setCountConfirmed(res.data.count_confirmed);
                setCountLivre(res.data.count_livre);
                setCountRetour(res.data.count_retourne);
                setCountAnnule(res.data.count_annule);

                if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            .catch((error) => {
                // // console.error(error);
            });

    }

    const labelsCharges = [t("Livraison"), t("Marketing"), t("Salaires"), t("Stock"), t("Frais de stockage"), t("Frais d'emballage"), t("Frais de maintenance"), t("Frais d'assurance"), t("Frais de service client"), t("Frais de matériel"), t("Abonnement aux plateformes"), t("Autre")];

    const dataChartCharges = {
        labels: labelsCharges,
        datasets: [
            {
                label: t("Charges"),
                data: [
                    (chargesData?.livraison || 0),
                    (chargesData?.marketing || 0),
                    (chargesData?.salaires || 0),
                    (chargesData?.stock || 0),
                    (chargesData?.fraisStockage || 0),
                    (chargesData?.fraisEmballage || 0),
                    (chargesData?.fraisMaintenance || 0),
                    (chargesData?.fraisAssurance || 0),
                    (chargesData?.fraisServiceClient || 0),
                    (chargesData?.fraisMateriel || 0),
                    (chargesData?.fraisAbonnement || 0),
                    (chargesData?.autre || 0),
                ],
                backgroundColor: [
                    "#3182CE", "#805AD5", "#38A169", "#E53E3E", "#D69E2E", 
                    "#319795", "#D53F8C", "#DD6B20", "#4A5568", "#2C7A7B", 
                    "#00B5D8", "#A0AEC0"
                ],
                hoverOffset: 10,
                borderWidth: 0,
            },
        ],
    };

    const hasChargesData = dataChartCharges.datasets[0].data.some(d => d > 0);
    const totalChargesAmount = dataChartCharges.datasets[0].data.reduce((a, b) => a + b, 0);

    const centerTextPlugin = {
        id: 'centerText',
        beforeDraw: (chart) => {
            const { ctx, chartArea: { left, top, width, height } } = chart;
            ctx.save();
            const centerX = left + width / 2;
            const centerY = top + height / 2;

            // "TOTAL" label
            ctx.font = 'bold 10px Plus Jakarta Display';
            ctx.fillStyle = '#A0AEC0';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(t('TOTAL'), centerX, centerY - 10);

            // Amount
            ctx.font = 'bold 16px Plus Jakarta Display';
            ctx.fillStyle = selectColor;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(`${totalChargesAmount.toFixed(2)} ${currentBusiness?.currency || ''}`, centerX, centerY + 10);
            ctx.restore();
        }
    };

    const optionsCharges = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'right',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    padding: 15,
                    font: { size: 10, weight: '500' },
                    color: useColorModeValue('#4A5568', '#A0AEC0'),
                }
            },
            tooltip: {
                padding: 12,
                backgroundColor: useColorModeValue('white', '#1A202C'),
                titleColor: useColorModeValue('#2D3748', 'white'),
                bodyColor: useColorModeValue('#2D3748', 'white'),
                borderColor: '#805AD5',
                borderWidth: 1,
                bodyFont: { size: 14, weight: 'bold' },
                displayColors: true,
            }
        },
        cutout: '65%',
    };

    const labels = [t("Nouveau"), t("Encours"), t("Confirmée"), t("Livrée"), t("Retournée"), t("Annulée")];

    const dataChart = {
        labels: labels,
        datasets: [
            {
                label: "",
                data: [countNew, countPending, countConfirmed, countLivre, countRetour, countAnnule],
                backgroundColor: [
                    "rgba(54, 162, 235, 0.2)",
                    "rgba(246, 173, 85, 0.2)",
                    "rgba(104, 211, 145, 0.2)",
                    "rgba(153, 102, 255, 0.2)",
                    "rgba(153, 102, 255, 0.2)",
                    "rgba(255, 99, 132, 0.2)",

                ],
                borderColor: [
                    "rgb(54, 162, 235)",
                    "rgba(246, 173, 85)",
                    "rgb(104, 211, 145)",
                    "rgba(153, 102, 255)",
                    "rgba(153, 102, 255)",
                    "rgb(255, 99, 132)",


                ],
                borderWidth: 1,
            },
        ],
    };
    const options = {
        plugins: {
            title: {
                display: true,
                text: 'Orders Chart',
                font: {
                    size: 16,
                },
            },
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.dataset.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += context.parsed.y.toFixed(2);
                        }
                        return label;
                    }
                }
            }
        },
        scales: {
            y: {
                ticks: {
                    callback: function (value) {
                        return value.toFixed(2);
                    }
                }
            }
        }
    };



    const lineChartOptionsDashboard = {
        chart: {
            toolbar: {
                show: false,
            },
        },
        tooltip: {
            theme: "dark",
            y: {
                formatter: function (val) {
                    return val.toFixed(2);
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
        },
        xaxis: {
            type: "datetime",
            categories: [
                "Jan",
                t("Fév"),
                "Mar",
                t("Avr"),
                t("Mai"),
                t("Jui"),
                t("Juil"),
                t("Aou"),
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
            labels: {
                style: {
                    colors: "darkgray",
                    fontSize: "12px",
                },
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: "darkgray",
                    fontSize: "12px",
                },
                formatter: function (val) {
                    return val.toFixed(2);
                },
            },
        },
        legend: {
            show: false,
        },
        grid: {
            strokeDashArray: 5,
            borderColor: "gray"
        },
        fill: {
            type: "gradient",
            gradient: {
                shade: "dark",
                type: "vertical",
                shadeIntensity: 0,
                gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
                inverseColors: true,
                opacityFrom: 0.8,
                opacityTo: 0,
                stops: [],
            },
            colors: ["#582CFF", "#ff7b7b"],
        },
        colors: ["#582CFF", "#ff7b7b"],
    };

    // Settings for the slider
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

    };
    const settingsUsers = {
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

    };

    const fetchChiffreAffaire = async (userId, userRole) => {
        try {
            const res = await axiosClient.get(`/commandes/getChiffreAffaire/?client=${userId}&product=${selectedProduct}&dateStart=${dateStart}&dateEnd=${dateEnd}&userRole=${userRole}&business=${currentBusiness?.id}`);
            const rawCA = parseFloat(res.data) || 0;
            setChiffreAffaire(rawCA);

            if (rawCA === 0) {
                setChiffreAffaireConverted(0);
                setExchangeRate(1);
                return;
            }

            if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");
                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
                return;
            }

            // ── Exchange Rate Conversion ──────────────────────────────────────────
            const orderCur = currentBusiness?.order_currency?.toLowerCase();
            const sysCur = currentBusiness?.currency?.toLowerCase();

            if (!orderCur || !sysCur || orderCur === sysCur) {
                // No conversion needed
                setChiffreAffaireConverted(rawCA);
                setExchangeRate(1);
                return;
            }

            if (currentBusiness?.exchange_rate_type === 'Manual' && currentBusiness?.custom_exchange_rate) {
                const rate = parseFloat(currentBusiness.custom_exchange_rate);
                setExchangeRate(rate);
                setChiffreAffaireConverted(rawCA * rate);
            } else {
                // Auto: fetch from currency API
                try {
                    const rateRes = await fetch(
                        `https://latest.currency-api.pages.dev/v1/currencies/${orderCur}.json`
                    );
                    const rateData = await rateRes.json();
                    const rate = rateData?.[orderCur]?.[sysCur];
                    if (rate) {
                        setExchangeRate(rate);
                        setChiffreAffaireConverted(rawCA * rate);
                    } else {
                        setChiffreAffaireConverted(rawCA);
                        setExchangeRate(null);
                    }
                } catch (e) {
                    // // console.error('Erreur API taux de change:', e);
                    setChiffreAffaireConverted(rawCA);
                    setExchangeRate(null);
                }
            }
        } catch (error) {
            // // console.error('Error fetching data:', error);
            return null;
        }
    };
    const fetchProfitNet = async (userId) => {
        try {
            const res = await axiosClient.get(`/charges/getStatsCharges/?client=${userId}&product=${selectedProduct}&dateStart=${dateStart}&dateEnd=${dateEnd}&business=${currentBusiness?.id}`);
            const rawCharges = parseFloat(res.data) || 0;

            const orderCur = currentBusiness?.order_currency?.toLowerCase();
            const sysCur = currentBusiness?.currency?.toLowerCase();
            let rate = 1;

            if (orderCur && sysCur && orderCur !== sysCur) {
                if (currentBusiness?.exchange_rate_type === 'Manual' && currentBusiness?.custom_exchange_rate) {
                    rate = parseFloat(currentBusiness.custom_exchange_rate);
                } else {
                    try {
                        const rateRes = await fetch(`https://latest.currency-api.pages.dev/v1/currencies/${orderCur}.json`);
                        const rateData = await rateRes.json();
                        rate = rateData?.[orderCur]?.[sysCur] || 1;
                    } catch (e) {
                        // // console.error('Erreur API taux de change:', e);
                    }
                }
            }
            setExchangeRate(rate);
            setChargesStats(rawCharges);

            if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                // Vérifier si le toast n'est pas déjà affiché
                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
            }
        } catch (error) {
            // // console.error('Error fetching data:', error);
            return null;
        }
    };

    const fetchDataEvolution = async () => {
        try {
            // Fetch revenus data
            const revenusRes = await axiosClient.get(`/commandes/getRevenusByMonth/?client=${user?.id}&dateStart=${dateStart}&dateEnd=${dateEnd}&year=${year}&product=${selectedProduct}&userRole=${user?.role}&business=${currentBusiness?.id}`);
            if (revenusRes.data.error === 'Client is disabled.' && revenusRes.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                // Vérifier si le toast n'est pas déjà affiché
                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
            }
            const revenusData = revenusRes.data || [];

            // Fetch charges data (adjust according to your actual API endpoint and logic)
            const chargesRes = await axiosClient.get(`/charges/getChargesByMonth/?client=${user?.id}&dateStart=${dateStart}&dateEnd=${dateEnd}&year=${year}&product=${selectedProduct}&userRole=${user?.role}&business=${currentBusiness?.id}`);
            if (chargesRes.data.error === 'Client is disabled.' && chargesRes.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                // Vérifier si le toast n'est pas déjà affiché
                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
            }
            const chargesData = chargesRes.data || [];

            // ── Exchange Rate Conversion ──────────────────────────────────────────
            const orderCur = currentBusiness?.order_currency?.toLowerCase();
            const sysCur = currentBusiness?.currency?.toLowerCase();
            let rate = 1;

            if (orderCur && sysCur && orderCur !== sysCur) {
                if (currentBusiness?.exchange_rate_type === 'Manual' && currentBusiness?.custom_exchange_rate) {
                    rate = parseFloat(currentBusiness.custom_exchange_rate);
                } else {
                    try {
                        const rateRes = await fetch(`https://latest.currency-api.pages.dev/v1/currencies/${orderCur}.json`);
                        const rateData = await rateRes.json();
                        rate = rateData?.[orderCur]?.[sysCur] || 1;
                    } catch (e) {
                        // // console.error('Erreur API taux de change:', e);
                    }
                }
            }
            setExchangeRate(rate);

            // Set line chart data
            setLineChartData([
                {
                    name: t("Revenus"),
                    data: revenusData.map(v => v * rate),
                },
                {
                    name: t("Charges"),
                    data: chargesData.map(v => v),
                },
            ]);


        } catch (error) {
            // // console.error('Error fetching data:', error);
        }
    };
    const fetchCharges = async (userId) => {
        axiosClient.get(`/charges/getCharges/?client=${userId}&dateStart=${dateStart}&dateEnd=${dateEnd}&product=${selectedProduct}&userRole=${user?.role}&business=${currentBusiness?.id}`)
            .then((response) => {
                setChargesData(response.data)

                if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            .catch((error) => {
                // // console.error(error);

            });
    };
    const fetchCosts = async (userId, userRole) => {
        axiosClient.get(`/commandes/getCosts/?client=${userId}&product=${selectedProduct}&dateStart=${dateStart}&dateEnd=${dateEnd}&userRole=${userRole}&business=${currentBusiness?.id}`)
            .then((response) => {
                setCostsData(response.data)

                if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            .catch((error) => {
                // // console.error(error);

            });
    };
    const fetchTaux = async (userId, userSuivi, userRole) => {
        axiosClient.get(`/commandes/getTaux/?client=${userId}&product=${selectedProduct}&dateStart=${dateStart}&dateEnd=${dateEnd}&userSuivi=${userSuivi}&userRole=${userRole}&business=${currentBusiness?.id}`)
            .then((response) => {
                // console.log("Taux ! ", response.data);

                setTauxData(response.data)

                if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            .catch((error) => {
                // // console.error(error);

            });
    };
    const loadProductOptions = async (search, loadedOptions, { page }) => {
        try {
            const res = await axiosClient.get(`/products/get_All_Products_names/?client=${user?.id}&page_size=20&page=${page}&search_term=${search}&userRole=${user?.role}&business=${currentBusiness?.id}`, { hideLoader: true });
            const results = res.data.results || [];
            const hasMore = res.data.next !== null && res.data.next !== undefined;

            return {
                options: results.map(product => ({
                    value: product.id,
                    label: product.title
                })),
                hasMore: hasMore,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            // // console.error('Error fetching products', error);
            return { options: [], hasMore: false };
        }
    };

    const fetchProductsNames = async (userId, userRole) => {
        // Le fetching est maintenant géré dynamiquement par loadProductOptions
    };

    const fetchProducts = async (userId, productId, userRole) => {
        axiosClient.get(`/products/getAllProducts/?page=1&page_size=10&id_user=${userId}&product=${productId}&userRole=${userRole}&business=${currentBusiness?.id}`)
            .then((response) => {
                setProducts(response.data.results)

                if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            .catch((error) => {
                // // console.error(error);
            });
    };
    const fetchUsers = async (userId) => {
        axiosClient.get(`/clients/getClientUsers/?page=1&page_size=99999&id=${userId}&business=${currentBusiness?.id}`)
            .then((response) => {
                setUsers(response.data.results)
            })
            .catch((error) => {
                // // console.error(error);
            });
    };
    const fetchProductStats = async (userId, productId, userRole) => {
        axiosClient.get(`/commandes/getStatsProduct/?client=${userId}&product=${productId || null}&dateStart=${dateStart}&dateEnd=${dateEnd}&userRole=${userRole}&business=${currentBusiness?.id}`)
            .then((response) => {
                setProductStats(response.data)

                if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            .catch((error) => {
                // // console.error(error);
            });
    };
    const fetchUsersStats = async (userId, staff, productId) => {
        axiosClient.get(`/clients/getStatsUsersSuivi/?client=${userId}&staff=${staff || null}&product=${productId || null}&dateStart=${dateStart}&dateEnd=${dateEnd}&business=${currentBusiness?.id}`)
            .then((response) => {
                // console.log("res", response.data);

                setUsersStatsSuivi(response.data)

                if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            .catch((error) => {
                // // console.error(error);
            });
        axiosClient.get(`/clients/getStatsUsersStock/?client=${userId}&staff=${staff || null}&product=${productId || null}&dateStart=${dateStart}&dateEnd=${dateEnd}&business=${currentBusiness?.id}`)
            .then((response) => {
                setUsersStatsStock(response.data)

                if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            .catch((error) => {
                // // console.error(error);
            });
    };
    useEffect(() => {
        if (user?.id && resetting) {
            onCloseCollapse();
            onCloseUsersCollapse()
            fetchDataEvolution();
            fetchBarData(user?.id, user?.role);
            fetchChiffreAffaire(user?.id, user?.role);
            fetchProfitNet(user?.id);
            fetchCharges(user?.id);
            fetchCosts(user?.id, user?.role);
            fetchTaux(user?.id, SelectedSuiviUser, user?.role)
            fetchProductsNames(user?.id, user?.role);
            fetchProducts(user?.id, selectedProduct, user?.role);
            fetchUsers(user?.id);
            fetchProductStats(user?.id, selectedProduct ? selectedProduct : productId, user?.role);
            fetchUsersStats(user?.id, selectedUser?.id, selectedProduct);
            setResetting(false);  // Reset the resetting state
            setSelectedSuiviUser("")
        }
    }, [user?.id, resetting]);

    const onClickStats = () => {
        if (user?.id) {
            if ((dateStart || year)) {
                setLineChartData(null)
                fetchDataEvolution();
            }
            if (year === "") {
                fetchDataEvolution();
            }
            fetchDataEvolution();
            fetchBarData(user?.id, user?.role);
            fetchCharges(user?.id)
            fetchCosts(user?.id, user?.role)
            fetchTaux(user?.id, SelectedSuiviUser, user?.role)
            fetchProductsNames(user?.id, user?.role)
            fetchProducts(user?.id, selectedProduct, user?.role)
            fetchUsers(user?.id)
            fetchProductStats(user?.id, selectedProduct ? selectedProduct : productId, user?.role)
            fetchUsersStats(user?.id, selectedUser?.id, selectedProduct);
            // onCloseDrawer()
            onOpenCollapse()
        }
    }
    useEffect(() => {
        if (user?.id) {
            if ((dateStart || year)) {
                setLineChartData(null)
                fetchDataEvolution();
            }
            if (year === "") {
                fetchDataEvolution();
            }
            fetchDataEvolution();
            fetchBarData(user?.id, user?.role);
            fetchChiffreAffaire(user?.id, user?.role);
            fetchProfitNet(user?.id);
            fetchCharges(user?.id)
            fetchCosts(user?.id, user?.role)
            fetchTaux(user?.id, SelectedSuiviUser, user?.role)
            fetchProductsNames(user?.id, user?.role)
            fetchProducts(user?.id, selectedProduct, user?.role)
            fetchUsers(user?.id)
            fetchProductStats(user?.id, selectedProduct ? selectedProduct : productId, user?.role)
            fetchUsersStats(user?.id, selectedUser?.id, selectedProduct);
        }

    }, [user?.id, productId, year, selectedUser?.id, SelectedSuiviUser, dateStart, dateEnd, selectedProduct]);

    const reset = () => {
        setDateStart('');
        setDateEnd('');
        setSelectedProduct('');
        setSelectedProductObj(null);
        setSelectionRange({
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        });
        setResetting(true);
    };

    const clearDateRange = () => {
        setDateStart('');
        setDateEnd('');
        setSelectionRange({
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        });
    };

    const getMinEndDate = (startDate) => {
        if (!startDate) return '';
        const date = new Date(startDate);
        date.setDate(date.getDate() + 1);
        return date.toISOString().split('T')[0];
    };

    const borderColor = useColorModeValue("gray.300", "gray.600");
    const bgCollapse = useColorModeValue("gray.50", "gray.700");
    const selectBg = useColorModeValue("white", "#1B254B");
    const selectColor = useColorModeValue("black", "white");
    const focusedOptionBg = useColorModeValue("#F4F7FE", "#2D3748");

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: selectBg,
            borderColor: state.isFocused ? "#805AD5" : borderColor,
            color: selectColor,
            borderRadius: "12px",
            padding: "2px",
            boxShadow: state.isFocused ? "0 0 0 1px #805AD5" : "none",
            "&:hover": {
                borderColor: "#805AD5"
            }
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: selectBg,
            borderRadius: "12px",
            zIndex: 9999
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#805AD5"
                : state.isFocused
                    ? focusedOptionBg
                    : selectBg,
            color: state.isSelected ? "white" : selectColor,
            cursor: "pointer",
            "&:active": {
                backgroundColor: "#805AD5"
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: selectColor
        }),
        input: (provided) => ({
            ...provided,
            color: selectColor
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "gray.400"
        })
    };

    return (
        <Flex mt={2} flexDirection='column' position={"relative"}>
            <style>{styles}</style>
            {/* -----------------Filter drawer button ----------------- */}
            <Flex zIndex={999} position={"fixed"} bottom={10} right={5}>
                <Button

                    onClick={() => {
                        onOpenDrawer()
                    }}
                    colorScheme='purple'
                >
                    <FaFilter size={18} />

                </Button>
            </Flex>

            {/* -----------------Header section ----------------- */}
            <Flex mt={2} flexDirection={{ base: 'column', md: "row" }} justifyContent="space-between" justify={"center"}>
                <Flex>
                    <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "30px" }} color="gray">

                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Statistiques")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Flex>


            </Flex>
            {/* -----------------top section ----------------- */}
            <Grid
                templateColumns={{ sm: '1fr', lg: '1.5fr 1.5fr' }}
                maxW={{ sm: '100%', md: '100%' }}
                gap='24px'
                my='20px'>

                {/* -----------------Order statuses section ----------------- */}
                <Card rounded={'xl'} p={{ base: "5px", md: "15px" }}>
                    <CardBody>
                        <Flex direction='column' w='100%'>
                            <Box
                                bg={useColorModeValue('linear-gradient(71deg, rgba(255,255,255,1) 0%, rgba(239,229,253,1) 53%, rgba(214,188,250,1) 100%)', 'linear-gradient(71deg, rgba(50,62,81,1) 0%, rgba(65,49,117,1) 100%)')}
                                borderRadius='20px'
                                shadow={'xl'}
                                w='100%'

                                // minH={{ sm: '300px' }}
                                display={{ sm: 'flex', md: 'block' }}
                                justify={{ sm: 'center', md: 'flex-center' }}
                                align={{ sm: 'center', md: 'flex-start' }}
                                minH={{ base: '180px', md: '220px' }}
                                p={{ base: '15px', sm: "20px", md: '22px' }}>

                                <Bar style={{ width: "100%" }} data={dataChart} options={options} />
                            </Box>
                            <Flex direction='column' mt='24px' mb='10px' alignSelf='flex-start'>
                                <Text fontSize='lg' fontWeight='bold' mb='6px'>
                                    {t("Statuts des commandes")}
                                </Text>
                                {/* <Text fontSize='md' fontWeight='medium' color='gray.400'>
									<Text as='span' color='green.400' fontWeight='bold'>
										(+23%)
									</Text>{' '}
									than last week
								</Text> */}
                            </Flex>
                            <SimpleGrid gap={{ base: "12px", sm: '12px' }} columns={{ base: 2, md: 3 }}>
                                <Flex direction='column'>
                                    <Flex alignItems='center'>
                                        <IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
                                            <MdOutlineAddShoppingCart size={"23px"} />
                                        </IconBox>
                                        <Text fontSize='sm' color='gray.400'>
                                            {t("Nouveau")}
                                        </Text>
                                    </Flex>
                                    <Text
                                        fontSize={{ sm: 'md', lg: 'lg' }}

                                        fontWeight='bold'
                                        mb='6px'
                                        my='6px'>
                                        {countNew}
                                    </Text>
                                    <Progress colorScheme='brand' bg='blue.300' borderRadius='30px' h='5px' value={20} />
                                </Flex>
                                <Flex direction='column'>
                                    <Flex alignItems='center'>
                                        <IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
                                            <TbTruckDelivery size={"23px"} />
                                        </IconBox>
                                        <Text fontSize='sm' color='gray.400'>
                                            {t("Encours")}
                                        </Text>
                                    </Flex>
                                    <Text
                                        fontSize={{ sm: 'md', lg: 'lg' }}

                                        fontWeight='bold'
                                        mb='6px'
                                        my='6px'>
                                        {countPending}
                                    </Text>
                                    <Progress colorScheme='brand' bg='yellow.300' borderRadius='30px' h='5px' value={90} />
                                </Flex>
                                <Flex direction='column'>
                                    <Flex alignItems='center'>
                                        <IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
                                            <MdOutlineAddShoppingCart size={"23px"} />
                                        </IconBox>
                                        <Text fontSize='sm' color='gray.400'>
                                            {t("Confirmée")}
                                        </Text>
                                    </Flex>
                                    <Text
                                        fontSize={{ sm: 'md', lg: 'lg' }}

                                        fontWeight='bold'
                                        mb='6px'
                                        my='6px'>
                                        {countConfirmed}
                                    </Text>
                                    <Progress colorScheme='brand' bg='green.300' borderRadius='30px' h='5px' value={20} />
                                </Flex>
                                <Flex direction='column'>
                                    <Flex alignItems='center'>
                                        <IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
                                            <TbTruckDelivery size={"23px"} />
                                        </IconBox>
                                        <Text fontSize='sm' color='gray.400'>
                                            {t("Livrée")}
                                        </Text>
                                    </Flex>
                                    <Text
                                        fontSize={{ sm: 'md', lg: 'lg' }}

                                        fontWeight='bold'
                                        mb='6px'
                                        my='6px'>
                                        {countLivre}
                                    </Text>
                                    <Progress colorScheme='brand' bg='purple.300' borderRadius='30px' h='5px' value={90} />
                                </Flex>
                                <Flex direction='column'>
                                    <Flex alignItems='center'>
                                        <IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
                                            <TbTruckReturn size={"23px"} />
                                        </IconBox>
                                        <Text fontSize='sm' color='gray.400'>
                                            {t("Retournée")}
                                        </Text>
                                    </Flex>
                                    <Text
                                        fontSize={{ sm: 'md', lg: 'lg' }}

                                        fontWeight='bold'
                                        mb='6px'
                                        my='6px'>
                                        {countRetour}
                                    </Text>
                                    <Progress colorScheme='brand' bg='orange.300' borderRadius='30px' h='5px' value={30} />
                                </Flex>
                                <Flex direction='column'>
                                    <Flex alignItems='center'>
                                        <IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
                                            <LuPackageX size={"23px"} />
                                        </IconBox>
                                        <Text fontSize='sm' color='gray.400'>
                                            {t("Annulée")}
                                        </Text>
                                    </Flex>
                                    <Text
                                        fontSize={{ sm: 'md', lg: 'lg' }}

                                        fontWeight='bold'
                                        mb='6px'
                                        my='6px'>
                                        {countAnnule}
                                    </Text>
                                    <Progress colorScheme='brand' bg='red.300' borderRadius='30px' h='5px' value={50} />
                                </Flex>
                            </SimpleGrid>
                        </Flex>
                    </CardBody>
                </Card>

                {/* -----------------top right section ----------------- */}
                <Flex h={'auto'} gap={5} flexDirection={'column'} >

                    {/* -----------------general cards stats section ----------------- */}
                    <Flex gap={5}>
                        <Card w={"50%"} rounded={'xl'} p='10px '>
                            <CardHeader ps='22px'>
                                <Flex direction='column' alignSelf='flex-start' justifyContent={"space-between"}>
                                    <Text fontSize='lg' fontWeight='bold' mb='6px'>
                                        {t("Chiffre d'affaire")}
                                    </Text>
                                    {/* Converted CA: order_currency → system currency */}
                                    <Text fontWeight='semibold'>
                                        {(chiffreAffaireConverted !== null || Number(chiffreAffaire || 0) === 0)
                                            ? `${Number(chiffreAffaireConverted ?? 0).toFixed(2)} ${currentBusiness?.currency || ''}`
                                            : `${Number(chiffreAffaire || 0).toFixed(2)} ${currentBusiness?.order_currency || ''}`
                                        }
                                    </Text>
                                    {/* Show original + rate if conversion happened and CA is not zero */}
                                    {chiffreAffaireConverted !== null &&
                                        currentBusiness?.order_currency !== currentBusiness?.currency &&
                                        Number(chiffreAffaire || 0) !== 0 && (
                                            <Text fontSize='xs' color='gray.400'>
                                                {Number(chiffreAffaire || 0).toFixed(2)} {currentBusiness?.order_currency}
                                                {exchangeRate ? ` × ${exchangeRate.toFixed(4)}` : ''}
                                                {currentBusiness?.exchange_rate_type === 'Auto' ? ' (auto)' : ' (manuel)'}
                                            </Text>
                                        )}
                                </Flex>
                            </CardHeader>
                        </Card>
                        <Card w={"50%"} rounded={'xl'} p='10px '>
                            <CardHeader ps='22px'>
                                <Flex direction='column' alignSelf='flex-start'>
                                    <Text fontSize='lg' fontWeight='bold' mb='6px'>
                                        {t("Profit net")}
                                    </Text>
                                    <Text fontWeight='semibold'>
                                        {((chiffreAffaireConverted ?? chiffreAffaire ?? 0) - (chargesStats || 0)).toFixed(2)}
                                        {' '}{currentBusiness?.currency || ''}
                                    </Text>
                                </Flex>
                            </CardHeader>
                        </Card>
                    </Flex>
                    {/* ----------------- Evolution of Income and Expenses section ----------------- */}
                    <Card h={"100%"} rounded={'xl'} p='10px '>
                        <CardHeader ps='22px'>
                            <Flex alignItems={"center"} gap={3} mb='2px' direction={{ base: "column", md: 'row' }} justifyContent={"space-between"} >
                                <Text w={{ base: "100%", md: "75%", lg: "70%" }} fontSize='lg' fontWeight='bold' >
                                    {t("Évolution des Revenus et des Charges")}
                                </Text>
                                {/* <Input onChange={ e=> setYear(e.target.value)} value={year} w={{base:"100%",md:"25%",lg:"30%"}} type='month'/> */}
                                {!dateStart && (
                                    <Select rounded={'lg'} w={{ base: "100%", md: "25%", lg: "30%" }} defaultValue={year} onChange={handleYearChange} >
                                        <option value="0">	{t("années")}</option>
                                        {generateYearOptions()}

                                    </Select>
                                )}
                            </Flex>
                        </CardHeader>
                        <Box mb={2} w='100%' h={{ base: '200px', sm: "300px" }}>
                            {lineChartData &&
                                <LineChart
                                    lineChartData={lineChartData}
                                    lineChartOptions={lineChartOptionsDashboard}
                                />}

                        </Box>
                    </Card>
                </Flex>

            </Grid>

            {/* -----------------products list section ----------------- */}
            {products?.length > 0 &&
                <Flex flexDirection={"column"} px={8} width="100%" >
                    <Flex align={"center"} justifyContent={"space-between"}>
                        <Text py={5} fontSize={"24px"}>{t("Liste des produits")}</Text>
                        <Flex _hover={{
                            color: "blue.500"
                        }} textDecoration={"underline"} cursor={"pointer"} gap={1} align={"center"} justify={"center"}>
                            <Text onClick={() => navigate('/products')} py={5} fontSize={"17px"}>{t("Voir tout")}</Text>
                            <IoIosArrowForward fontSize={"13px"} />

                        </Flex>


                    </Flex>
                    <Slider  {...settings} style={{ width: '100%', height: "100%" }}>
                        {products?.map((product, index) => (

                            <Flex cursor={"pointer"} onClick={() => {
                                setProductId(product.id)
                                onOpenCollapse()
                            }

                            } w={"100%"} flexDirection={'column'} justifyContent={"center"} alignItems={'center'}>
                                <Image
                                    h={"150px"}
                                    borderRadius={"20px"}
                                    key={index}
                                    src={product?.images[0].image}
                                    objectFit="contain"
                                    mx="5px"
                                    padding={2}
                                />
                                <Text w={"100%"} textAlign={"center"}>{product.title}</Text>

                                {/* <Flex bg={'green'} w={"90%"} flexDirection={'column'} justifyContent={"center"} alignItems={"center"}>
                             <Image
                                 borderRadius={"20px"}
                                 key={index}
                                 src={slideImage?.image}
                                 objectFit="contain"
                                 mx="5px"
                                 padding={2}
                             />
                             <Text w={"100%"} bg={"yellow"} textAlign={"center"}>title</Text>
                         </Flex> */}
                            </Flex>

                        ))}

                        {/* <Flex
                 
                 border={"1px"}
                 borderColor={'gray.400'}
                 height={"100%"}
                 borderRadius={"20px"}
                 
                 width={"100%"}
                 padding={2}
                 onClick={onToggle}  
                 flexDirection={'column'} 
                 justifyContent={"center"} 
                 alignItems={'center'}>
                 
         
                 <Text height={"100%"}>
                     voir plus
                 </Text>


             </Flex> */}

                    </Slider>
                    <Collapse mt='4' in={isCollapseOpen} >
                        <Box
                            p='20px'
                            // color='black'

                            // bg='gray.50'
                            rounded='md'
                        // shadow='md'
                        // boxShadow={"2xl"}
                        >
                            <Flex w={"100%"} justifyContent={"flex-end"}>
                                <CloseButton mr={-5} onClick={() => onCloseCollapse()} size='md' />

                            </Flex>

                            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={{ base: 5, lg: 8 }}>
                                <StatsCard title={t('nombre de fois commandé')} stat={productStats?.product_ordered} icon={<MdAddShoppingCart size={'3em'} />} />
                                <StatsCard title={t('nombre de fois livré')} stat={productStats?.product_delivered} icon={<LiaShippingFastSolid size={'3em'} />} />
                                <StatsCard title={t('nombre de fois annulé')} stat={productStats?.product_canceled} icon={<MdOutlineRemoveShoppingCart size={'3em'} />} />
                            </SimpleGrid>
                        </Box>
                    </Collapse>
                </Flex>
            }


            {/* -----------------users list section ----------------- */}
            {users?.length > 0 &&

                <Flex pb={3} flexDirection={"column"} px={8} width="100%" height="100%">
                    <Text py={5} fontSize={"24px"}>{t("Liste des personnels")}</Text>
                    <Slider {...settingsUsers} style={{ width: '100%', height: "100%" }}>

                        {users?.map((user, index) => (
                            <>
                                <Flex w={"100%"} flexDirection={'column'} justifyContent={"center"} alignItems={'center'}>
                                    {/* <Avatar
                            
                            size={"2xl"}
                            key={index}
                            src={slideImage?.image}
                            objectFit="contain"
                            mx="5px"
                            padding={2}
                        />
                        <Text w={"100%"} textAlign={"center"}>title 2</Text> */}

                                    <Flex onClick={() => {
                                        setSelectedUser(user);
                                        onOpenUsersCollapse()
                                        // setSelectedUserId(user.id)
                                    }

                                    } w={"90%"} flexDirection={'column'} justifyContent={"center"} alignItems={"center"}>
                                        <Avatar

                                            size={"xl"}
                                            key={index}
                                            src={user?.image}
                                            objectFit="contain"
                                            mx="5px"
                                            padding={2}
                                        />
                                        <Text w={"100%"} textAlign={"center"}>{user.first_name} {user.last_name}</Text>
                                    </Flex>
                                </Flex>
                            </>


                        ))}
                    </Slider>
                    <Collapse in={isCollapseUsersOpen} >
                        <Box
                            p='20px'
                            rounded='md'
                        >

                            {selectedUser?.role_client === "RespoSuiviClient" ?
                                <>
                                    <Flex w={"100%"} justifyContent={"flex-end"}>
                                        <CloseButton mr={-5} onClick={() => onCloseUsersCollapse()} size='md' />
                                    </Flex>
                                    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={{ base: 5, lg: 8 }}>
                                        <UsersStatsCard title={t('Nombre de commandes en cours')} stat={usersStatsSuivi?.num_commandes_en_cours} icon={<MdAddShoppingCart size={'3em'} />} />
                                        <UsersStatsCard title={t('Nombre de commandes confirmés')} stat={usersStatsSuivi?.num_commandes_confirmes} icon={<LiaShippingFastSolid size={'3em'} />} />
                                        <UsersStatsCard title={t('Nombre de commandes livrés')} stat={usersStatsSuivi?.num_commandes_livres} icon={<MdOutlineRemoveShoppingCart size={'3em'} />} />
                                        <UsersStatsCard title={t('Nombre de commandes annulés')} stat={usersStatsSuivi?.num_commandes_annules} icon={<MdOutlineRemoveShoppingCart size={'3em'} />} />
                                    </SimpleGrid>
                                </>

                                :
                                selectedUser?.role_client === "StockManagerClient"
                                    ?
                                    <>
                                        <Flex w={"100%"} justifyContent={"flex-end"}>
                                            <CloseButton mr={-5} onClick={() => onCloseUsersCollapse()} size='md' />
                                        </Flex>
                                        < SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={{ base: 5, lg: 8 }}>
                                            <UsersStatsCard title={t('Nombre de commandes en cours')} stat={usersStatsStock?.num_commandes_en_cours} icon={<MdAddShoppingCart size={'3em'} />} />
                                            <UsersStatsCard title={t('Nombre de commandes Emballés')} stat={usersStatsStock?.num_commandes_embales} icon={<LiaShippingFastSolid size={'3em'} />} />
                                            <UsersStatsCard title={t('Nombre de commandes Collectés')} stat={usersStatsStock?.num_commandes_collecte} icon={<MdOutlineRemoveShoppingCart size={'3em'} />} />
                                            <UsersStatsCard title={t('Nombre de commandes annulés')} stat={usersStatsStock?.num_commandes_annules} icon={<MdOutlineRemoveShoppingCart size={'3em'} />} />
                                        </SimpleGrid>
                                    </>

                                    : null
                            }
                        </Box>
                        {/* <Flex
                mt='5'
                w={"100%"}

                alignItems={"center"}
                justifyContent={"center"}
            // shadow='md'
            >
                {selectedUserId?.role_client === "RespoSuiviClient" ?
                    <Flex
                        rounded='md'
                        p='20px'
                        bg={bgCollapse}
                        w={"50%"}
                        flexDirection={"column"}>
                        <Text>Nombre de commandes en cours : 1500</Text>
                        <Text>Nombre de commandes confirmés : 1500</Text>
                        <Text>Nombre de commandes livrés : 1500</Text>
                        <Text>Nombre de commandes annulé : 1500</Text>
                    </Flex>
                    : selectedUserId?.role_client === "StockManagerClient"
                        ?
                        <Flex
                            rounded='md'
                            p='20px'
                            bg={bgCollapse}
                            w={"50%"}
                            flexDirection={"column"}>
                            <Text>Nombre de commandes en cours : 1500</Text>
                            <Text>Nombre de commandes Emballés : 2800</Text>
                            <Text>Nombre de commandes Collectés : 2800</Text>
                        </Flex> : null
                }

            </Flex> */}
                    </Collapse>
                </Flex>
            }


            {/* -----------------bottom section ----------------- */}
            <Grid
                templateColumns={{ sm: '1fr', lg: '1.9fr 1.1fr' }}
                maxW={{ sm: '100%', md: '100%' }}
                gap='24px'
                my='20px'>

                {/* -----------------charges stats section ----------------- */}
                <Card rounded={'xl'} p={{ base: "5px", md: "15px" }}>
                    <CardHeader>
                        <Flex direction='column' alignSelf='flex-start'>
                            <Text fontSize='lg' fontWeight='bold' >
                                {t("Statistiques des charges")}
                            </Text>

                        </Flex>
                    </CardHeader>
                    <CardBody>
                        <Flex direction='column' w='100%'>
                            <Box
                                bg={useColorModeValue('linear-gradient(71deg, rgba(255,255,255,1) 0%, rgba(239,229,253,1) 53%, rgba(214,188,250,1) 100%)', 'linear-gradient(71deg, rgba(50,62,81,1) 0%, rgba(65,49,117,1) 100%)')}
                                borderRadius='20px'
                                shadow={'xl'}
                                w='100%'

                                // minH={{ sm: '300px' }}
                                display={{ sm: 'flex', md: 'block' }}
                                justify={{ sm: 'center', md: 'flex-center' }}
                                align={{ sm: 'center', md: 'flex-start' }}
                                minH={{ base: '180px', md: '220px' }}
                                p={{ base: '15px', sm: "20px", md: '22px' }}>

                                <Box w="100%" h="100%" minH="220px" display="flex" alignItems="center" justifyContent="center">
                                    {hasChargesData ? (
                                        <Doughnut 
                                            style={{ width: "100%" }} 
                                            data={dataChartCharges} 
                                            options={optionsCharges} 
                                            plugins={[centerTextPlugin]}
                                        />
                                    ) : (
                                        <Flex direction="column" align="center" justify="center" w="100%" py={10}>
                                            <Icon as={MdOutlineBarChart} w={12} h={12} color="gray.300" mb={4} />
                                            <Text fontSize="md" color="gray.400" fontWeight="500">
                                                {t("Aucune donnée de charge disponible")}
                                            </Text>
                                            <Text fontSize="xs" color="gray.500">
                                                {t("Les charges apparaîtront ici une fois ajoutées")}
                                            </Text>
                                        </Flex>
                                    )}
                                </Box>
                            </Box>


                        </Flex>
                    </CardBody>
                </Card>

                {/* -----------------bottom right costs cards section ----------------- */}
                <Flex flexDirection={"column"} gap={5} >
                    <Card rounded={'xl'} p='16px' height={"fit-content"} overflowX={{ sm: 'scroll', xl: 'hidden' }}>

                        <CardHeader pl={0}>
                            <Flex direction='column' alignSelf='flex-start'>
                                <Text fontSize='lg' fontWeight='bold' >
                                    {t("Coûts")}
                                </Text>

                            </Flex>
                        </CardHeader>
                        <Card mb={2} shadow={'none'}>
                            <CardBody alignItems={"center"} display={"flex"} justifyContent={"space-between"} p={2}>
                                <Flex align={"center"} gap={2}>
                                    <Flex fontSize={'md'} direction={"column"}>
                                        <Text>{t("Coût par prospect")}</Text>
                                    </Flex>
                                </Flex>
                                <Badge gap={1} display={"flex"} rounded={"lg"} px={4} py={1} variant='subtle' colorScheme='orange'>
                                    <Text fontSize={16} >
                                        {parseFloat(costsData?.cost_per_lead).toFixed(2)}
                                    </Text>

                                </Badge>
                            </CardBody>
                        </Card>
                        <Card mb={2} shadow={'none'}>
                            <CardBody alignItems={"center"} display={"flex"} justifyContent={"space-between"} p={2}>
                                <Flex align={"center"} gap={2}>
                                    <Flex fontSize={'md'} direction={"column"}>
                                        <Text>{t("Coût par prospect confirmé")}</Text>
                                    </Flex>
                                </Flex>

                                <Badge gap={1} display={"flex"} rounded={"lg"} px={4} py={1} variant='subtle' colorScheme='green'>
                                    <Text fontSize={16} >
                                        {parseFloat(costsData?.cost_per_confirmed_lead).toFixed(2)}
                                    </Text>

                                </Badge>
                            </CardBody>
                        </Card>
                        <Card mb={2} shadow={'none'}>
                            <CardBody alignItems={"center"} display={"flex"} justifyContent={"space-between"} p={2}>
                                <Flex align={"center"} gap={2}>
                                    <Flex fontSize={'md'} direction={"column"}>
                                        <Text>{t("Coût par prospect livré")}</Text>
                                    </Flex>
                                </Flex>

                                <Badge gap={1} display={"flex"} rounded={"lg"} px={4} py={1} variant='subtle' colorScheme='blue'>
                                    <Text fontSize={16} >
                                        {parseFloat(costsData?.cost_per_delivered_lead).toFixed(2)}
                                    </Text>

                                </Badge>
                            </CardBody>
                        </Card>


                    </Card>
                    <Card rounded={'xl'} p='16px' height={"fit-content"} overflowX={{ sm: 'scroll', xl: 'hidden' }}>

                        <CardHeader pl={0}>
                            <Flex align={"center"} gap={5} direction='row' justifyContent={"space-between"}>
                                <Text w={"40%"} fontSize='lg' fontWeight='bold' >
                                    {t("Taux")}
                                </Text>
                                <Select w={"60%"} size={"sm"} rounded={"md"} value={SelectedSuiviUser} onChange={(e) => setSelectedSuiviUser(e.target.value)}>
                                    <option value="">{t("Choisissez un responsable de suivi")}</option>
                                    {users?.filter(e => e?.role === "RespoSuiviClient")?.map((user) => (
                                        <option value={user?.id}>{user?.first_name} {user.last_name}</option>

                                    ))}
                                </Select>

                            </Flex>
                        </CardHeader>
                        <Card mb={2} shadow={'none'}>
                            <CardBody alignItems={"center"} display={"flex"} justifyContent={"space-between"} p={2}>
                                <Flex align={"center"} gap={2}>
                                    <Flex fontSize={'md'} direction={"column"}>
                                        <Text>{t("Taux de confirmation")}</Text>
                                    </Flex>
                                </Flex>
                                <Badge rounded={"lg"} px={4} py={1} variant='subtle' colorScheme='cyan'>
                                    <Text fontSize={15} >
                                        {parseFloat(tauxData?.taux_confirmation).toFixed(2)} %
                                    </Text>
                                </Badge>
                            </CardBody>
                        </Card>
                        <Card mb={2} shadow={'none'}>
                            <CardBody alignItems={"center"} display={"flex"} justifyContent={"space-between"} p={2}>
                                <Flex align={"center"} gap={2}>
                                    <Flex fontSize={'md'} direction={"column"}>
                                        <Text>{t("Taux de livraison")}</Text>
                                    </Flex>
                                </Flex>
                                <Badge rounded={"lg"} px={4} py={1} variant='subtle' colorScheme='purple'>
                                    <Text fontSize={15} >
                                        {parseFloat(tauxData?.taux_delivery).toFixed(2)} %
                                    </Text>
                                </Badge>
                            </CardBody>
                        </Card>


                    </Card>
                </Flex>

            </Grid>

            {/* -----------------filters drawer----------------- */}
            <Drawer
                isOpen={isDrawerOpen}
                placement='left'
                initialFocusRef={firstField}
                onClose={onCloseDrawer}
            >
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth='1px'>
                        {t("Filtrer par")} :
                    </DrawerHeader>

                    <DrawerBody>
                        <Flex gap={5} flexDirection={"column"} align="center">
                            <Box w="full">
                                <Text mb={2} fontWeight="bold">{t("Période")}</Text>
                                <Popover placement="bottom-start">
                                    <PopoverTrigger>
                                        <InputGroup>
                                            <Input
                                                readOnly
                                                value={dateStart ? `${dateStart} ${t("au")} ${dateEnd}` : t("Choisir une période")}
                                                cursor="pointer"
                                                rounded="xl"
                                            />
                                            {dateStart && (
                                                <InputRightElement>
                                                    <IconButton
                                                        variant="ghost"
                                                        size="sm"
                                                        icon={<CloseButton size="sm" />}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            clearDateRange();
                                                        }}
                                                        aria-label={t("Effacer la date")}
                                                    />
                                                </InputRightElement>
                                            )}
                                        </InputGroup>
                                    </PopoverTrigger>
                                    <PopoverContent w="auto" p={0} border="none">
                                        <PopoverArrow />
                                        <PopoverBody p={0}>
                                            <DateRange
                                                ranges={[selectionRange]}
                                                onChange={handleSelect}
                                                locale={fr}
                                                maxDate={new Date()}
                                                rangeColors={['#805AD5']}
                                            />
                                        </PopoverBody>
                                    </PopoverContent>
                                </Popover>
                            </Box>
                            <Divider borderColor={'gray.300'} my={2} />
                            <Box w="full">
                                <Text mb={2} fontWeight="bold">{t("Produit")}</Text>

                                <AsyncPaginate
                                    loadOptions={loadProductOptions}
                                    additional={{ page: 1 }}
                                    styles={customSelectStyles}
                                    value={selectedProductObj}
                                    onChange={(option) => {
                                        setSelectedProductObj(option);
                                        setSelectedProduct(option ? option.value : "");
                                    }}
                                    isClearable
                                    placeholder={t("Choisissez un produit")}
                                    noOptionsMessage={() => t("Aucun produit trouvé")}
                                />
                            </Box>
                        </Flex>

                    </DrawerBody>

                    <DrawerFooter display={'flex'} justifyContent="center" borderTopWidth='1px'>
                        <Button 
                            leftIcon={<GrPowerReset />}
                            colorScheme="purple" 
                            w="full"
                            onClick={() => reset()}
                        >
                            {t("Réinitialiser")}
                        </Button>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>

        </Flex >
    )
}

export default Statistics